module.exports = __webpack_public_path__ + "img/resize-icon-mr.e227c444.svg";